import Vue from 'vue'

const state = {
  details: {},
  permissionLevel: 0,
  logs: [],
  users: []
}

const getters = {
  userDetails: (state) => state.details,
  userLogs: (state) => state.logs,
  users: (state) => state.users,
  permissionLevel: (state) => state.permissionLevel
}

const actions = {
  async getUserDetails ({commit}) {
    const {body} = await Vue.http.get('/user/details')

    commit('setUserDetails', body.data)
    commit('setUserPermissionLevel', body.data.permissions)
  },
  async saveUserDetails (context, details) {
    await Vue.http.put('/user/details', details)
  },
  async getUserLogs ({commit}) {
    const {body} = await Vue.http.get('/user/logs')
    commit('setUserLogs', body.data)
  },
  async getAllUsers ({commit}) {
    const {body} = await Vue.http.get('/users')
    commit('setUsers', body.data)
  },
  async createUser (context, data) {
    await Vue.http.post('/user', data)
  },
  async updateUserDetails (context, data) {
    await Vue.http.put('/user/details', data)
  },
  async getUser ({getters, dispatch}, id) {
    const {users} = getters

    for (let user of users) {
      if (user.id === id) {
        return
      }
    }

    // Get all users since we are already making a request
    await dispatch('getAllUsers')
  }
}

const mutations = {
  setUserDetails (state, details) {
    state.details = details
  },
  setUserPermissionLevel (state, level) {
    state.permissionLevel = level
  },
  setUsers (state, users) {
    state.users = users
  },
  setUserLogs (state, logs) {
    state.logs = logs
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js